import Middle from "./middle/middle";
import TeamBlock from "./teamBlock/teamBlock";
import "./bodyCardListSponsored.sass";

/**
 * Muestra el cuerpo central de una tarjeta de evento patrocinado, incluyendo
 * equipos izquierdo y derecho, marcador y momios centrales.
 */
export default function BodyCardListSponsored({ item, patrocinador, flagMomios, clase }) {
  if (!item || typeof item !== "object") return null;

  const { left_class, left_image, left_score, left_short_name, left_name,
    right_class, right_image, right_score, right_short_name, right_name,
    utc_date, period_title, opta_event_url, sport
  } = item;

  const patrocinadorKey = patrocinador?.toLowerCase() || "";
  const patrocinadorMetadata = item?.[`${patrocinadorKey}_metadata`] || {};
  
  const leftTeam = { teamClass: left_class, image: left_image, score: left_score, shortName: left_short_name, fullName: left_name };
  const rightTeam = { teamClass: right_class, image: right_image, score: right_score, shortName: right_short_name, fullName: right_name };

  const linkClass = `card-list-sponsored__body${!flagMomios ? " bodyTop30" : ""}`;

  return (
    <a href={opta_event_url} target="_parent" rel="noreferrer" className={linkClass}>
      <TeamBlock name={leftTeam.shortName} image={leftTeam.image} position="left" sport={sport}/>

      <Middle
        left_mm={patrocinadorMetadata.left_mm} left_url_mm={patrocinadorMetadata.left_url_mm} left_score={left_score}
        middle_mm={patrocinadorMetadata.middle_mm} middle_url_mm={patrocinadorMetadata.middle_url_mm}
        right_mm={patrocinadorMetadata.right_mm} right_url_mm={patrocinadorMetadata.right_url_mm} right_score={right_score}
        date={utc_date} clase={clase} period_title={period_title} left_class={left_class} right_class={right_class}
      />

      <TeamBlock name={rightTeam.shortName} image={rightTeam.image} position="right" sport={sport}/>
    </a>
  )
}